/** Matches `PublicNavbar` fixed offset (`top: 20px`). */
export const PUBLIC_NAVBAR_TOP_OFFSET_PX = 20;

/** Matches `PublicNavbar` card `minH`. */
export const PUBLIC_NAVBAR_MIN_HEIGHT_PX = 82;

/** Extra space below the navbar when scrolling to in-page anchors. */
export const PUBLIC_SCROLL_MARGIN_GAP_PX = 20;

/** `scroll-margin-top` for anchor targets that should clear the public navbar. */
export function publicScrollMarginBelowNavbar(
  gapPx = PUBLIC_SCROLL_MARGIN_GAP_PX,
): string {
  return `${PUBLIC_NAVBAR_TOP_OFFSET_PX + PUBLIC_NAVBAR_MIN_HEIGHT_PX + gapPx}px`;
}
